import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router';

import { addRole, updateRole, setEditingRole, modifyRole, getRoleById } from 'roles/actions';

import { addGrowlMessage, clearGrowlMessages } from 'messages/actions';

import { getPermissionsList } from 'containers/lists/actions';

import * as Common from 'common/components';

import RoleForm from 'roles/components/RoleForm';

import { getCompany } from 'auth/selectors';
import { getEditingRole } from 'roles/selectors';
import { getIsLoading, getPermissionsBySection } from 'lists/selectors';

import { valueFromEvent } from 'lib/util';

class RolesFormContainer extends Component {
  state = { isValid: false, isSubmitted: false };

  componentWillMount = () => {
    this.props.getPermissionsList();
    this.props.setEditingRole();
    // If role id present on url fetch it!
    if (this.props.match.params.roleId) this.props.getRoleById();
  };

  handleValueChange = (e) => {
    return this.props.modifyRole(valueFromEvent(e));
  };

  handleSubmit = (e, data) => {
    this.setState({ isSubmitted: true }, () => {
      this.props.clearGrowlMessages();
      if (!this.state.isValid && this.state.isSubmitted) {
        this.props.addGrowlMessage('error.verify', 'danger', 'common.error');
      }
      return (
        this.state.isValid &&
        this.props
          .saveRole(this.props.role)
          .then(({ value }) => {
            this.props.addGrowlMessage(value.message, 'success', 'common.success');
            this.props.history.push(`/companies/${this.props.company.id}/roles`);
          })
          .catch((err) => this.props.addGrowlMessage(err.message, 'danger', 'common.error'))
      );
    });
  };

  handleValidation = (isValid, message) => {
    this.setState({ isValid });
  };

  handleCheckSection = (e) => {
    const permissions = this.props.permissions.bySection[e.target.value];
    if (e.target.checked) {
      this.props.modifyRole({
        permissions: [...this.props.role.permissions, ...permissions],
      });
    } else {
      this.props.modifyRole({
        permissions: this.props.role.permissions.filter((p) => permissions.indexOf(p) === -1),
      });
    }
  };

  handleCheckPermission = (e) => {
    if (e.target.checked) {
      this.props.modifyRole({
        permissions: [...this.props.role.permissions, e.target.value],
      });
    } else {
      this.props.modifyRole({
        permissions: this.props.role.permissions.filter((p) => p !== e.target.value),
      });
    }
  };

  handleClickPermissionRow = (e, permission) => {
    if (e.target.tagName !== 'INPUT') {
      if (this.props.role.permissions.indexOf(permission) > -1) {
        this.props.modifyRole({
          permissions: this.props.role.permissions.filter((p) => p !== permission),
        });
      } else {
        this.props.modifyRole({
          permissions: [...this.props.role.permissions, permission],
        });
      }
    }
  };

  render = () => (
    <Common.PageWrapper fluid={true}>
      {/* <Common.PageHeader title={this.props.t("roles.title")} /> */}
      <div className="col-12">
        <Common.Portlet
          title={
            this.props.t('menu.control_panel') +
            ' > ' +
            this.props.t('roles.subtitle') +
            ' > ' +
            this.props.t(
              this.props.match.params.roleId ? 'roles.form_edit_title' : 'roles.form_add_title'
            )
          }
          icon={this.props.match.params.roleId ? 'pencil-square-o' : 'plus-circle'}
        >
          <RoleForm
            companyId={this.props.company.id}
            handleSubmit={this.handleSubmit}
            handleValidation={this.handleValidation}
            handleValueChange={this.handleValueChange}
            id={this.props.match.params.roleId}
            isSubmitted={this.state.isSubmitted}
            isLoading={this.props.role.isSaving}
            isLoadingPermissions={this.props.isLoadingPermissions}
            permissions={this.props.permissions}
            handleCheckSection={this.handleCheckSection}
            handleCheckPermission={this.handleCheckPermission}
            handleClickPermissionRow={this.handleClickPermissionRow}
            t={this.props.t}
            values={this.props.role}
          />
          <Common.LoaderOverlay show={this.props.role.isLoading} />
        </Common.Portlet>
      </div>
    </Common.PageWrapper>
  );
}

const mapStateToProps = (state) => {
  return {
    company: getCompany(state),
    role: getEditingRole(state),
    isLoadingPermissions: getIsLoading(state),
    permissions: getPermissionsBySection(state),
  };
};

const mapDispatchToProps = (
  dispatch,
  {
    match: {
      params: { id, roleId },
    },
  }
) => ({
  addGrowlMessage: (text, type, title) => dispatch(addGrowlMessage(text, type, title)),
  clearGrowlMessages: () => dispatch(clearGrowlMessages()),
  saveRole: (data) => dispatch(roleId ? updateRole(id, roleId, data) : addRole(id, data)),
  setEditingRole: () => dispatch(setEditingRole()),
  modifyRole: (data) => dispatch(modifyRole(data)),
  getPermissionsList: () => dispatch(getPermissionsList(id)),
  getRoleById: () => dispatch(getRoleById(id, roleId)),
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  translate()
)(RolesFormContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/roles/containers/RoleFormContainer.js